import { render, staticRenderFns } from "./card-image-url.vue?vue&type=template&id=3548f8bb&scoped=true&"
import script from "./card-image-url.vue?vue&type=script&lang=js&"
export * from "./card-image-url.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3548f8bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/botter-dashbaord/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib'
import { VExpansionPanelContent } from 'vuetify/lib'
installComponents(component, {VExpansionPanel,VExpansionPanelContent})
